import {Component, OnInit} from '@angular/core';
import {SecurityData} from "../security-data";

@Component({
  selector: 'cap-forbidden',
  templateUrl: './forbidden.component.html'
})
export class ForbiddenComponent implements OnInit {

  constructor(public securityData: SecurityData) {
  }

  ngOnInit() {
  }

}
